//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'

export default {
  components: {
    VueClazyLoad
  },
  props: {
    value: {
      required: false,
      default: null
    },
    competition: {
      default: null
    },
    filters: {
      default: null
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  computed: {
    seguro_combinada_config() {
      return this.$store.getters.seguroCombinadaConfig
    },
    seguro_combinada_scopes() {
      const sportConfigs = _.get(this.seguro_combinada_config, 'sport_configs', [])
      return _.flatMap(sportConfigs, (sc) => sc.config || [])
    },
    seguroCombinadaEligible() {
      if (!this.seguro_combinada_config || !this.competition) return false

      const sportId = _.get(this.competition, 'sport.id') || _.get(this.competition, 'sport_id')
      const sportSlug = _.get(this.competition, 'sport.slug') || _.get(this.competition, 'sport_slug')
      const providerCompetitionId = _.get(this.competition, 'id')

      return this.seguro_combinada_scopes.some((scope) => {
        if (scope.provider_sport_id && scope.provider_sport_id !== sportId) return false
        if (scope.sport_id && String(scope.sport_id).toLowerCase() !== String(sportSlug).toLowerCase()) return false
        if (scope.provider_competition_id && scope.provider_competition_id !== providerCompetitionId) return false
        return true
      })
    }
  },
  mounted() {
    this._onDocumentClick = (event) => {
      if (!this.showTooltip) return
      const wrapper = this.$refs.seguroWrapper
      if (wrapper && !wrapper.contains(event.target)) {
        this.showTooltip = false
      }
    }
    document.addEventListener('click', this._onDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this._onDocumentClick)
  }
}
